// Brand tokens for Noir Pétale Parfumerie.
// Mirrors what was in the Velo project's public/brand.js — kept here as the
// frontend source of truth. Tailwind picks these up via globals.css custom
// properties so utility classes can reference them as bg-ink, text-bone, etc.

export const colors = {
  ink:      '#0E1420',
  bone:     '#F4EFE6',
  gold:     '#C9A84C',
  goldSoft: '#9A8038',
  rose:     '#A88EA0',
} as const;

export const fonts = {
  // Display = bold uppercase modernist sans (Aesop / Glossier register).
  // The italic Cormorant from the original brief was dropped after Bradley
  // chose the Nous Deux Wix template, which is bold sans throughout.
  display:  '"Inter Tight", "Inter", -apple-system, "Segoe UI", sans-serif',
  body:     '"Inter", -apple-system, "Segoe UI", sans-serif',
  numerals: '"Inter Tight", "Inter", sans-serif',
} as const;

export const business = {
  name:        'Noir Pétale Parfumerie',
  shortName:   'Noir Pétale',
  contactEmail:'noirpetale.co@gmail.com',
  contactPhone:'(351) 322-5409',
  returnDays:  14,
  url:         'https://noirpetale.com',
} as const;

export const voice = {
  anchor:
    "Noir Pétale is for the everyday person who wants to smell incredible " +
    "without overspending on big-name brands. We curate fragrances at an " +
    "in-between price point — quality scents that feel luxurious but don't " +
    "price out the people who'd wear them every day.",
} as const;
